module.exports = __webpack_public_path__ + "img/tr.04c3ed17.png";